import { Component, OnInit } from '@angular/core';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { CNDepartment } from 'src/app/models/cndepartment';
import { CNUser } from 'src/app/models/cnuser';
import { UserDomain } from 'src/app/models/custom/userdomain';
import { SNUser } from 'src/app/models/snuser';
import { UserService } from 'src/app/services/user.service';
import { UserDepartmentService } from 'src/app/services/user/user-department.service';

@ManageType('UserAdminDialogComponent')
@Component({
  selector: 'app-user-admin-dialog',
  templateUrl: './user-admin-dialog.component.html',
  styleUrls: ['./user-admin-dialog.component.scss']
})
export class UserAdminDialogComponent implements OnInit {

  private selectedUser: CNUser;
  public userDepartments: CNDepartment[];
  public userGroups: SNUser[];
  public userDomains: UserDomain[];

  constructor(private department: UserDepartmentService, private user: UserService) { }

  ngOnInit(): void {
  }

  public selectUser(user: CNUser) {
    this.selectedUser = user;
    this.department.userDepartments(user).subscribe(departments => {
      this.userDepartments = departments;
    });
    this.user.groups(user).subscribe(groups => {
      this.userGroups = groups;
    });
    this.user.domains(user).subscribe(domains => {
      this.userDomains = domains;
    });
  }
}
